import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPrinter2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="printer-2, print"><path fillRule="evenodd" clipRule="evenodd" d="M14.5 8C15.8807 8 17 9.11929 17 10.5V18.5C17 19.8807 15.8807 21 14.5 21H9.5C8.11929 21 7 19.8807 7 18.5V10.5C7 9.11929 8.11929 8 9.5 8H14.5ZM10 16.5H12.5V15H10V16.5ZM10 12.5H14V11H10V12.5Z" fill="currentColor"/><path d="M18 3C20.2091 3 22 4.79086 22 7V9C22 10.6569 20.6569 12 19 12H18.5V10.5C18.5 8.29086 16.7091 6.5 14.5 6.5H9.5C7.29086 6.5 5.5 8.29086 5.5 10.5V12H5C3.34315 12 2 10.6569 2 9V7C2 4.79086 3.79086 3 6 3H18Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPrinter2;
